export default {
    waitForServerConfig: true,
    waitForServerLanguage: true,
    themeColor:'#0284bb',
}
